module.exports = __webpack_public_path__ + "static/media/rsna18-event-top10.68e223ff.svg";